export default __webpack_public_path__ + "static/media/Studenti.98e5830e.jpg";